




import { Component, Vue } from 'vue-property-decorator'
import FacebookPostReportTable from './FacebookPostReportTable/index.vue'


@Component({
    components: { FacebookPostReportTable }
})
export default class SystemReports extends Vue {
}
